export const LOADING_SX = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  minHeight: '400px',
};

export const CONTAINER_SX = {
  width: '100%',
  height: '100%',
  overflow: 'auto',
  backgroundColor: 'white',
  padding: '40px',
};

export const CONTENT_SX = {
  maxWidth: '800px',
  margin: '0 auto',
  backgroundColor: 'white',
  padding: '60px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  '& p': {
    margin: '8px 0',
    lineHeight: '1.6',
    fontSize: '14px',
  },
  '& h1': {
    margin: '24px 0 16px',
    fontSize: '28px',
    fontWeight: 'bold',
    lineHeight: '1.3',
  },
  '& h2': {
    margin: '20px 0 12px',
    fontSize: '22px',
    fontWeight: 'bold',
    lineHeight: '1.3',
  },
  '& h3': {
    margin: '16px 0 8px',
    fontSize: '18px',
    fontWeight: 'bold',
    lineHeight: '1.3',
  },
  '& h4': {
    margin: '12px 0 8px',
    fontSize: '16px',
    fontWeight: 'bold',
    lineHeight: '1.3',
  },
  '& ul, & ol': {
    margin: '8px 0',
    paddingLeft: '32px',
  },
  '& li': {
    margin: '4px 0',
    lineHeight: '1.6',
  },
  '& table': {
    width: '100%',
    borderCollapse: 'collapse',
    margin: '16px 0',
  },
  '& td, & th': {
    border: '1px solid #ddd',
    padding: '8px 12px',
    textAlign: 'left',
  },
  '& th': {
    backgroundColor: '#f5f5f5',
    fontWeight: 'bold',
  },
  '& img': {
    maxWidth: '100%',
    height: 'auto',
    margin: '16px 0',
  },
  '& strong': {
    fontWeight: 'bold',
  },
  '& em': {
    fontStyle: 'italic',
  },
  '& blockquote': {
    margin: '16px 0',
    padding: '12px 20px',
    borderLeft: '4px solid #ddd',
    backgroundColor: '#f9f9f9',
  },
};
